import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "ml-class.org vs. real world ML class",
  "description": "",
  "published": "2011-10-11T00:00:00.000Z",
  "redirect_from": ["/blog/ml-class-org-vs-real-world-ml-class/swizec/2617"],
  "categories": "Artificial intelligence, E-learning, Machine learning, Professor, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/959a08a818b54dc89eb397dcf05b959e_74.jpg",
        "alt": null,
        "title": "An online class"
      }}></img></p>
    <p>{`Due to `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-suck-at-formal-education-or-does-education-suck/swizec/2564",
        "title": "I suck at [formal] education or does education suck?"
      }}>{`circumstances not completely out of my control`}</a>{` I am in a unique position this semester to take a whole bunch of interesting classes strewn from all over - I am officially attending only three at my college.`}</p>
    <p>{`As part of my new found freedom I'm sitting in on a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Machine_learning",
        "title": "Machine learning"
      }}>{`Machine Learning`}</a>{` class by professor Kononenko and coincidentally I'm also taking the two new `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/E-learning",
        "title": "E-learning"
      }}>{`online classes`}</a>{` `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.43,-122.17&spn=0.01,0.01&q=37.43,-122.17%20(Stanford%20University)&t=h",
        "title": "Stanford University"
      }}>{`Stanford`}</a>{` is offering this year - `}<a parentName="p" {...{
        "href": "http://ml-class.org"
      }}>{`Machine Learning`}</a>{` and `}<a parentName="p" {...{
        "href": "http://ai-class.org"
      }}>{`Artificial Intelligence`}</a>{`.`}</p>
    <p>{`The real world class started off last week and went just as you'd expect such. The room was packed full of bright young minds sighing and moaning at every mention that this class might actually require a bit of effort on their part. The professor meanwhile giddily explaining how the class is going to work, how people are getting graded ... Later got to the introductory overview of what he'll be teaching all semester.`}</p>
    <p>{`Perhaps more surprising is that this introductory part of the course took three hours of everyone's lives. Sure, it was interesting, but that's a lot of time. Especially since the same class took three hours again today and didn't get much beyond introductory stuff (practical applications and types of learning).`}</p>
    <p>{`That's about 300 man hours wasted on telling everyone the rules, overview of the material and some practical ideas.`}</p>
    <p>{`Solid.`}</p>
    <p>{`Stanford, on the other hand, takes a different approach. Every week videos are posted online, I haven't seen all of them yet, but that's the beauty of it ... I can watch whenever I feel like. And the videos are chunked into short topical bits so I can rewatch any part that doesn't make sense.`}</p>
    <p>{`Neither of the luxuries apply when you're dealing with a real world class.`}</p>
    <p>{`When I was watching the first hour of lectures today in a lovely coffee shop, out on a grassy field surrounded by the autumn, evening sun and some trees I realized that this was alright. This is going to work!`}</p>
    <p>{`The way the class is presented is also different.`}</p>
    <p>{`The overview part and the rules was done with in the first ten minutes, the next twenty minutes were some practical applications, but not in an overviewy airy way. Nope, the applications and approaches were done through examples. You didn't just get the feeling `}<em parentName="p">{`what`}</em>{` an approach is good for, it was also `}<em parentName="p">{`how`}</em>{` it happened. Not the details, but you could quickly grasp the gist of what's going on in this approach.`}</p>
    <p>{`An interesting difference is also how in the real world class, the professor mostly tells us stuff, shows some pictures and sometimes gets interrupted by a question.`}</p>
    <p>{`In the Stanford class the professor mostly tells stuff, shows a bunch of pictures and draws a `}<em parentName="p">{`lot`}</em>{`. But every ten minutes or so `}<em parentName="p">{`he`}</em>{` poses a question. And not a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Rhetorical_question",
        "title": "Rhetorical question"
      }}>{`rhetorical question`}</a>{`. The kind where you actually `}<em parentName="p">{`engage.`}</em>{` It's bloody awesome.`}</p>
    <p>{`The online class feels almost like having a personal tutor and the real world class ... well it feels like a class.`}</p>
    <p>{`Wonder if Kononenko knows about ml-class.org ... hope he does... I should ask him next time.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.i-programmer.info/news/150-training-a-education/2999-registration-open-for-worldwide-online-ai-class.html"
        }}>{`Registration open for worldwide online AI class`}</a>{` (i-programmer.info)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.ml-class.org/"
        }}>{`Stanford Fall 2011 - Machine Learning`}</a>{` (ml-class.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.gubatron.com/blog/2011/10/10/today-starts-the-stanford-online-ai-course/"
        }}>{`Today starts the Stanford online AI Course`}</a>{` (gubatron.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ml-class.org/"
        }}>{`Machine Learning - Stanford University`}</a>{` (ml-class.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=08a673e1-aaa3-498b-85ec-9b8972a262df",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      